
import router, { addroutes, homeData, routes } from '@/router';
import ElementUI from 'element-ui';
import store from '../store/vuex.js';


// router.addRoutes(routes.concat(addroutes))
//路由拦截 获取正确路由列表
router.beforeEach((to, from, next) => {
	// 本地的所有路由
	var role = addroutes;
	// 左侧渲染的列表
	var menu = store.state.menu;
	var key = localStorage.getItem('user_key')
	if(!key){
		if(to.path=='/'||to.path=='/agreement'){
			next()
		} else {
			ElementUI.Message.error('未登录请登录')
			setTimeout(()=>{
				next('/')
			},1000)
		}
	}else{
		if(menu.length==0){
			var user = JSON.parse(localStorage.getItem('UserData')) 
			if(user.JobNumber=='00001'){
				store.commit('setMenu',role[0].children)
				router.addRoutes(routes.concat(role))
				next({...to})
			}else{
				store.dispatch('setMenu',role).then(res=>{
					router.addRoutes(routes.concat(res))
					next({...to})
				}).catch(err=>{
					if(err.code == 200){
						store.commit('setMenu',homeData[0].children)
						router.addRoutes(routes.concat(homeData))
						next({ ...to })
					}
				})
			}
		}else{
			var time = new Date().getTime()
			if(time > key){
				ElementUI.Message.error('登录已失效，请重新登录。')
				localStorage.removeItem('user_key')
				next({ path: '/' })
			}
			else next()
		}
		
	}
  // next()
})
